import request from '@/utils/request'

// 查询合同管理列表
export function listnonContract(query) {
  return request({
    url: '/cont/nonbusiness/list',
    method: 'get',
    params: query
  })
}

// 查询f非业务合同详细
export function getNonBusinessContract(contractId) {
  return request({
    url: '/cont/nonbusiness/' + contractId,
    method: 'get'
  })
}

// 新增合同管理
export function addnonContract(data) {
  return request({
    url: '/cont/nonbusiness',
    method: 'post',
    data: data
  })
}

// 修改合同管理
export function updateNonContract(data) {
  return request({
    url: '/cont/nonbusiness',
    method: 'put',
    data: data
  })
}

// 删除合同管理
export function delnonContract(contractId) {
  return request({
    url: '/cont/nonbusiness/' + contractId,
    method: 'delete'
  })
}

// 导出合同管理
export function exportContract(query) {
  return request({
    url: '/cont/nonbusiness/export',
    method: 'get',
    params: query
  })
}

// 下载客户导入模板
export function importTemplate() {
  return request({
    url: '/cont/nonbusiness/importTemplate',
    method: 'get'
  })
}